import React from 'react';
import '../../styles/RateCard.css';

const LivesPodcastsBeHealth = () => {
    return (
        <section className="lives-podcasts-be-health-section py-5" id='lives'>
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Lives & Podcasts<br /><span className="highlight-bg">BeHealth</span>
                        </h2>
                        <p className="mt-4">
                            BeHealth Live es una transmisión en tiempo real diseñada para comunicar información clave, responder preguntas, 
                            mostrar productos o cubrir eventos importantes. Este formato fomenta un alto nivel de interacción con un público 
                            altamente interesado en el momento, ofreciendo a las marcas una oportunidad única de visibilidad y engagement 
                            directo
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Conexión en tiempo real con audiencias segmentadas.</li>
                            <li>Participación activa de la marca en temas relevantes de salud.</li>
                            <li>Promoción cruzada en redes sociales y plataformas de BeHealth.</li>
                            <li>Posibilidad de personalizar anuncios y gráficas para maximizar el impacto.</li>
                            <li>Generación de contenido reutilizable para amplificación futura.</li>
                        </ul>
                        <div className="tab-label mt-4">Lives & Podcasts</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Tipos de auspicios</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#056059" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h3 className='fw-bold text-start mb-3'> <span className='bg-dark-teal p-2'>All access</span></h3>
                            <ul className="ps-4 mt-2 text-start">
                                <li>Mención como auspiciador destacado.</li>
                                <li>Logotipo en gráficas del programa (cintillos).</li>
                                <li>Logotipo en cobertura de redes sociales.</li>
                                <li>Exclusividad durante la transmisión.</li>
                                <li>Posibilidad de incluir anuncios (30 segundos) en el programa.</li>
                                <li>Contextualización del mensaje según el tema del Live.</li>
                            </ul>
                            <h3 className='fw-bold text-start'>Premium</h3>
                            <ul className="ps-4 mt-2 text-start">
                                <li>Mención como auspiciador.</li>
                                <li>Logotipo en gráficas del programa (cintillos).</li>
                                <li>Posibilidad de incluir anuncios (30 segundos) en el programa.</li>
                                <li>Contextualización del mensaje según el tema del Live.</li>
                            </ul>
                            <h3 className='fw-bold text-start'>Core</h3>
                            <ul className="ps-4 mt-2 text-start">
                                <li>Mención como auspiciador.</li>
                                <li>Logotipo en gráficas del programa (cintillos).</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default LivesPodcastsBeHealth;
